<div class="container" style="padding-top: 25px; padding-bottom: 25px;">

    <div class="row" style="background-color: cadetblue; border-radius: 10px; min-height: 500px;">
        <div class="col">
            welcome to classroom


        </div>
    </div>
</div>